import { render, staticRenderFns } from "./PriceSliderFilter.vue?vue&type=template&id=352eff50&"
import script from "./PriceSliderFilter.vue?vue&type=script&lang=js&"
export * from "./PriceSliderFilter.vue?vue&type=script&lang=js&"
import style0 from "./PriceSliderFilter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports